<template>
	<div>
		<firstsceen :imgobj='banner'>
			<div id="text1" class="w-100  cc" style="height: 100vh; z-index: 90;color: white;text-align: center;">
				<div>

					<div style=" font-family: YouSheBiaoTiHei; 
							font-size: 100px;  
							letter-spacing: 10px;
							-webkit-text-fill-color:transparent; 
							 -webkit-text-stroke:1px white; ">
						再小的星球在</div>

					<div
						style="margin-top: -25px; font-family: YouSheBiaoTiHei;font-size: 100px; letter-spacing: 10px;font-style: italic;">
						星链也能散发星光
					</div>

					<div style="font-size: 20px; letter-spacing: 2px;text-transform :uppercase;">
						no matter how samall the planet isit can
						also emit starlight in fashion link</div>

					<!-- <div style="height: 100px;"></div> -->

				</div>
			</div>
		</firstsceen>
		<div class="container">
			<!-- 导航栏 -->
			<div style="display: flex; font-size:15px; margin-top: -50px;">
				<div :class="[selectindex==0? 'tabaction':'tabitem']"
					style="font-weight: 400;text-align: center;margin-right:50px ;" @click="selecttab(0)">
					<div>招贤纳士</div>
					<div
						style="width: 32px;border-bottom: 2px solid;margin-left: auto;margin-right: auto;margin-top: 5px;">
					</div>
				</div>
				<div :class="[selectindex==1? 'tabaction':'tabitem']" style="font-weight: 400;text-align: center;"
					@click="selecttab(1)">
					<div>联系我们</div>
					<div
						style="width: 32px;border-bottom: 2px solid ;margin-left: auto;margin-right: auto;margin-top: 5px;">
					</div>
				</div>
			</div>
			<!-- 导航栏 end-->
			<div style="height: 20px;"></div>
		</div>
		<!-- 招贤纳士 -->
		<div v-if="selectindex==0">
			<div class="container" style="font-size: 16px;">
				<div style="display: flex;">
					<label style="font-weight: bold;margin-right: 30px;"> 工作地点：</label>
					<div>
						<label :class="[localselectindex==-1 ?'fontbold':'']" style="margin-right: 30px;"
							@click="onclickloacl(-1)"> 不限</label>

						<label v-for="(item, index) in locallist" :class="[localselectindex==index ?'fontbold':'']"
							style="margin-right: 30px;" @click="onclickloacl(index)"> {{item}}</label>
					</div>
				</div>
				<div style="margin-top: 35px;display: flex;">
					<label style="font-weight: bold;margin-right: 30px;"> 职位类别：</label>
					<div>
						<label :class="[typeselectindex==-1 ?'fontbold':'']" style="margin-right: 30px;"
							@click="onclicktype(-1)"> 不限</label>
						<label v-for="(item, index) in typelist" :class="[typeselectindex==index ?'fontbold':'']"
							style="margin-right: 30px;" @click="onclicktype(index)">
							{{item}}</label>
					</div>
				</div>

			</div>

			<div style="background-color: #F8F8F8;margin-top: 40px;">
				<div  style="padding-top: 30px;padding-bottom: 30px;">
					<div style="text-align: center;font-weight: bold;font-size: 18px;">
						<label class="hrlabel"> 职业名称</label>
						<label class="hrlabel"> 职业类别</label>
						<label class="hrlabel"> 工作地点</label>
						<label class="hrlabel"> 招聘人数</label>
						<label class="hrlabel"> 更新时间</label>
					</div>
					<div v-for="(item, index) in showlist">
						<div @click="clickitem(index)"
							style="background-color: white;height: 60px;line-height: 60px; text-align: center;font-size: 18px;">
							<label style="width: 180px;font-weight: bold;"> {{item.name}}</label>
							<label style="width: 180px;"> {{item.type}}</label>
							<label style="width: 180px;"> {{item.local}}</label>
							<label style="width: 180px;"> {{item.count}}</label>
							<label style="width: 180px;"> {{item.time}}</label>
						</div>
						<div v-if="showindex==index"
							style="width: 712px;margin-left: auto;margin-right: auto;white-space: pre-line;">
							{{item.des}}
						</div>
					</div>
				</div>
			</div>

		</div>
		<!-- 招贤纳士 end-->
		<div v-if="selectindex==1" style="background-color:  #F8F8F8;padding-top: 20px;">
			<div class="container" style="background-color: white;padding: 0px;">
				<div style="display: flex;">
					<div>
						<img class="contactmap" src="../../static/map.png">
					</div>
					<div style="padding:30px 0px 0px 20px;">
						<div style="font-weight: bold;font-size: 24px;margin-bottom: 40px;"> 联系我们</div>
						<div style="font-weight: bold;font-size: 18px;letter-spacing: 5px;margin-top: 30px;"> 温州总部</div>
						<div style="color: #666666;font-size: 16px;">
							地址：浙江省温州市鹿城区世界温州人家园2幢6楼
						</div>
						<div style="color: #666666;font-size: 16px;">
							电话：400-0718-0888
						</div>
						<div style="font-weight: bold;font-size: 18px;letter-spacing: 5px;margin-top: 30px;"> 深圳数字智能
						</div>
						<div style="color: #666666;font-size: 16px;">
							地址：浙江省温州市鹿城区世界温州人家园2幢6楼
						</div>
						<div style="color: #666666;font-size: 16px;">
							<!-- 电话：400-0718-0888 -->
						</div>
						<div style="font-weight: bold;font-size: 18px;letter-spacing: 5px;margin-top: 30px;"> 产品研发部门
						</div>
						<div style="color: #666666;font-size: 16px;">
							地址：浙江永嘉县千石奥康工业园
						</div>
						<div style="color: #666666;font-size: 16px;">
							<!-- 电话：400-0718-0888 -->
						</div>

					</div>
				</div>

				<div
					style="display: flex;	flex-wrap: wrap;background-color: white;padding: 52px;font-size: 16px;color: #666666;">
					<div class="contantitem">
						<div style="display: flex; line-height: 30px;">
							<img style="width: 30px;height: 30px;" src="../../static/商务咨询ico.png">
							<div>
								<div
									style="font-weight: bold;margin-left: 10px; margin-bottom: 20px;  color: #333333;letter-spacing: 5px;font-size: 24px;">
									商务咨询</div>
							</div>
						</div>
						<div>
							<div style="margin-left: 40px;font-weight: bold;">服务热线：
							</div>
							<div style="margin-left: 40px;margin-top: 5px;">400-0718-0888
							</div>
						</div>
						<div>
							<div style="margin-left: 40px;font-weight: bold;margin-top: 10px;">联系邮箱：
							</div>
							<div style="margin-left: 40px;margin-top: 5px;">yuanlequn@xlc2m.com
							</div>
						</div>
					</div>

					<div class="contantitem">
						<div style="display: flex; line-height: 30px;">
							<img style="width: 30px;height: 30px;" src="../../static/媒体联系ico.png">
							<div>
								<div
									style="margin-bottom: 20px;font-weight: bold;margin-left: 10px; color: #333333;letter-spacing: 5px;font-size: 24px;">
									媒体联系</div>
							</div>
						</div>
						<div>
							<div style="margin-left: 40px;font-weight: bold;">联系邮箱：
							</div>
							<div style="margin-left: 40px;margin-top: 5px;">chenbiao@xlc2m.com
							</div>
						</div>


					</div>

					<div class="contantitem">
						<div style="display: flex; line-height: 30px;">
							<img style="width: 30px;height: 30px;" src="../../static/招贤纳士ico.png">
							<div>
								<div
									style="margin-bottom: 20px;font-weight: bold;margin-left: 10px; color: #333333;letter-spacing: 5px;font-size: 24px;">
									商务咨询</div>
							</div>
						</div>
						<div>
							<div style="margin-left: 40px;font-weight: bold;">招贤纳士：
							</div>
							<div style="margin-left: 40px;margin-top: 5px;">13732029878
							</div>
						</div>
						<div>
							<div style="margin-left: 40px;font-weight: bold;margin-top: 10px;">联系邮箱：
							</div>
							<div style="margin-left: 40px;margin-top: 5px;">xingyuxin@xlc2m.com
							</div>
						</div>

					</div>

					<div class="contantitem">
						<div style="display: flex; line-height: 30px;">
							<img style="width: 30px;height: 30px;" src="../../static/社交媒体关注ico.png">
							<div>
								<div
									style="margin-bottom: 20px;font-weight: bold;margin-left: 10px; color: #333333;letter-spacing: 5px;font-size: 24px;">
									社交媒体关注</div>
							</div>
						</div>
						<div>
							<div style="margin-left: 40px;font-weight: bold;">微信公众号：
							</div>
							<div style="margin-left: 40px;margin-top: 5px;">fashionlink星链数据
							</div>
						</div>
						<div>
							<div style="margin-left: 40px;font-weight: bold;margin-top: 10px;">今日头条：
							</div>
							<div style="margin-left: 40px;margin-top: 5px;">
							</div>
						</div>
						<div>
							<div style="margin-left: 40px;font-weight: bold;margin-top: 10px;">微博：
							</div>
							<div style="margin-left: 40px;margin-top: 5px;">V品定制
							</div>
						</div>

					</div>

					<div class="contantitem">
						<div style="display: flex; line-height: 30px;">
							<img style="width: 30px;height: 30px;" src="../../static/小程序商城ico.png">
							<div>
								<div
									style="margin-bottom: 20px;font-weight: bold;margin-left: 10px; color: #333333;letter-spacing: 5px;font-size: 24px;">
									小程序商城</div>
							</div>
						</div>
						<div>
							<div style="margin-left: 40px;font-weight: bold;">咨询热线：
							</div>
							<div style="margin-left: 40px;margin-top: 5px;">400-0718-0888
							</div>
						</div>
						<div>
							<div style="margin-left: 40px;font-weight: bold;margin-top: 10px;">咨询客服：
							</div>
							<div style="margin-left: 40px;margin-top: 5px;">13626535915
							</div>
						</div>


					</div>
				</div>



			</div>
		</div>

	</div>
</template>
<script>
	import firstsceen from '../../components/firstsceenimagebase.vue'
	import banner from '../../static/星链也能散发星光.png'

	export default {
		name: 'Abouthr',
		components: {
			firstsceen,

		},
		data() {
			return {
				banner: banner,
				selectindex: 0,
				localselectindex: -1,
				typeselectindex: -1,
				locallist: ["温州", "深圳"],
				typelist: ["美术设计类", "行政类"],
				datalist:[],
				// datalist: [{
				// 	name: "UI设计师",
				// 	type: "美术设计类",
				// 	local: "温州",
				// 	count: 2,
				// 	time: "2022/02/01",
				// 	des: "工作职能：\n\n负责核心产品的用户体验设计，含UI设计和交互设计。制定产品的设计风格，界面设计、图标设计等\n专业的用户调研/竞品对比，分析产品用体验问题，提出体验问题解决方案，持续提升产品的用户体验\n制定UI设计规范，统一产品内的视觉元素，保障UI设计风格的统一性\n把控UI设计的开发落地，保障设计效果像素级还原。\n有动效设计经验、插画设计经验是加分项\n\n岗位要求：\n\n本科及以上学历，设计类专业，3年以上相关工作经验；\n有实战项目案例，对设计潮流形式和流行趋势把握敏锐，具备宽广的行业视野和出色的设计表达能力，能将趋势和设计结合，将有效的想法转化为设计方案；\n对工具类软件（三维建模/渲染/材质设计）有设计或长期使用经验者优先；\n有团队精神、创新精神和责任感，执行力强，能承受高强度的工作，具备良好的沟通能力，流畅阐述视觉观点和设计价值；\n熟练掌握Photoshop、Illustartor、sketch等设计软件，掌握C4D、AE等软件者优先考虑；\n具备英语工作环境或国际化产品项目经历者优先；有作品链接或者作品集。\n"

				// }, {
				// 	name: "UI设计师",
				// 	type: "美术设计类",
				// 	local: "温州",
				// 	count: 2,
				// 	time: "2022/02/01",
				// 	des: "工作职能：\n\n负责核心产品的用户体验设计，含UI设计和交互设计。制定产品的设计风格，界面设计、图标设计等\n专业的用户调研/竞品对比，分析产品用体验问题，提出体验问题解决方案，持续提升产品的用户体验\n制定UI设计规范，统一产品内的视觉元素，保障UI设计风格的统一性\n把控UI设计的开发落地，保障设计效果像素级还原。\n有动效设计经验、插画设计经验是加分项\n\n岗位要求：\n\n本科及以上学历，设计类专业，3年以上相关工作经验；\n有实战项目案例，对设计潮流形式和流行趋势把握敏锐，具备宽广的行业视野和出色的设计表达能力，能将趋势和设计结合，将有效的想法转化为设计方案；\n对工具类软件（三维建模/渲染/材质设计）有设计或长期使用经验者优先；\n有团队精神、创新精神和责任感，执行力强，能承受高强度的工作，具备良好的沟通能力，流畅阐述视觉观点和设计价值；\n熟练掌握Photoshop、Illustartor、sketch等设计软件，掌握C4D、AE等软件者优先考虑；\n具备英语工作环境或国际化产品项目经历者优先；有作品链接或者作品集。\n"
				// }, {
				// 	name: "UI设计师",
				// 	type: "美术设计类",
				// 	local: "温州",
				// 	count: 2,
				// 	time: "2022/02/01",
				// 	des: "工作职能：\n\n负责核心产品的用户体验设计，含UI设计和交互设计。制定产品的设计风格，界面设计、图标设计等\n专业的用户调研/竞品对比，分析产品用体验问题，提出体验问题解决方案，持续提升产品的用户体验\n制定UI设计规范，统一产品内的视觉元素，保障UI设计风格的统一性\n把控UI设计的开发落地，保障设计效果像素级还原。\n有动效设计经验、插画设计经验是加分项\n\n岗位要求：\n\n本科及以上学历，设计类专业，3年以上相关工作经验；\n有实战项目案例，对设计潮流形式和流行趋势把握敏锐，具备宽广的行业视野和出色的设计表达能力，能将趋势和设计结合，将有效的想法转化为设计方案；\n对工具类软件（三维建模/渲染/材质设计）有设计或长期使用经验者优先；\n有团队精神、创新精神和责任感，执行力强，能承受高强度的工作，具备良好的沟通能力，流畅阐述视觉观点和设计价值；\n熟练掌握Photoshop、Illustartor、sketch等设计软件，掌握C4D、AE等软件者优先考虑；\n具备英语工作环境或国际化产品项目经历者优先；有作品链接或者作品集。\n"
				// }, {
				// 	name: "UI设计师",
				// 	type: "行政类",
				// 	local: "深圳",
				// 	count: 2,
				// 	time: "2022/02/01",
				// 	des: "工作职能：\n\n负责核心产品的用户体验设计，含UI设计和交互设计。制定产品的设计风格，界面设计、图标设计等\n专业的用户调研/竞品对比，分析产品用体验问题，提出体验问题解决方案，持续提升产品的用户体验\n制定UI设计规范，统一产品内的视觉元素，保障UI设计风格的统一性\n把控UI设计的开发落地，保障设计效果像素级还原。\n有动效设计经验、插画设计经验是加分项\n\n岗位要求：\n\n本科及以上学历，设计类专业，3年以上相关工作经验；\n有实战项目案例，对设计潮流形式和流行趋势把握敏锐，具备宽广的行业视野和出色的设计表达能力，能将趋势和设计结合，将有效的想法转化为设计方案；\n对工具类软件（三维建模/渲染/材质设计）有设计或长期使用经验者优先；\n有团队精神、创新精神和责任感，执行力强，能承受高强度的工作，具备良好的沟通能力，流畅阐述视觉观点和设计价值；\n熟练掌握Photoshop、Illustartor、sketch等设计软件，掌握C4D、AE等软件者优先考虑；\n具备英语工作环境或国际化产品项目经历者优先；有作品链接或者作品集。\n"
				// }],
				showlist: [],
				showindex: -1,

			}
		},
		mounted() {
			this.showlist = this.datalist,
				this.selectindex = 1
		},

		methods: {
			selecttab: function(e) {
				this.selectindex = e
			},
			gopage: function(url) {
				this.$router.push(url)

			},
			onclickloacl: function(e) {
				this.localselectindex = e
				this.querylist()
			},
			onclicktype: function(e) {
				this.typeselectindex = e
				this.querylist()

			},
			clickitem: function(e) {
				if (this.showindex == e) {
					this.showindex = -1
				} else {
					this.showindex = e
				}

			},
			querylist: function() {
				this.showlist = []
				this.showindex = -1

				var selectlocal = this.localselectindex == -1 ? '不限' : this.locallist[this.localselectindex]
				var selecttype = this.typeselectindex == -1 ? '不限' : this.typelist[this.typeselectindex]
				var typeselectindex = this.typeselectindex
				var localselectindex = this.localselectindex
				var showlist = []
				this.datalist.forEach(function(value, index, array) {

					if ((typeselectindex == -1 || selecttype == value.type) && (localselectindex == -
							1 || selectlocal == value.local)) {
						showlist.push(value)
					}

				})
				this.showlist = showlist
			},
		}

	}
</script>

<style>
	.tabaction {
		color: #E8C570;
	}

	.tabitem {
		color: white;
	}

	.fontbold {
		font-weight: bold;
	}

	.contantitem {

		width: 400px;
		margin-bottom: 33px;
	}

	@media (min-width: 1px) {
		.contactmap {
			width: 100%;
		}

		.hrlabel {
			width: 80px;
		}
	}

	@media (min-width: 1000px) {
		.contactmap {
			width: 90%;
			height: 90%;
		}

		.hrlabel {
		 width: 180px;
		}
	}
</style>
